(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-global-footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-footer-top]')) return;
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const target = document.querySelector('#header-group a[href], .rm-standalone-header a[href], main');
    if (target) {
      if (target.tagName === 'MAIN') target.tabIndex = -1;
      target.focus({ preventScroll: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm26-warmup-entry"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const start=1792220400000,end=1793606340000,reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const forced=new URLSearchParams(location.search).get('rm26_warmup_preview')==='1';
  let timer;
  function update(){
    clearTimeout(timer);const now=Date.now(),scheduled=now>=start&&now<end;
    document.querySelectorAll('[data-rm26-entry]').forEach(entry=>{
      const preview=entry.dataset.editorPreview==='true'||(forced&&entry.dataset.previewAllowed==='true');
      entry.hidden=!(scheduled||preview);
      if(!entry.hidden){
        entry.querySelectorAll('[data-rm26-image]').forEach(image=>{if(!image.getAttribute('src')){image.srcset=image.dataset.srcset;image.src=image.dataset.src;}});
        if(preview&&forced)entry.querySelectorAll('a').forEach(link=>{const url=new URL(link.href);url.searchParams.set('rm26_warmup_preview','1');link.href=url.href;});
      }
    });
    const next=now<start?start:now<end?end:0;
    if(next)timer=setTimeout(update,Math.min(next-now,2147483647));
  }
  function observe(){
    document.querySelectorAll('[data-rm26-entry]:not([data-rm26-observed])').forEach(entry=>{
      entry.dataset.rm26Observed='true';
      const observer=new IntersectionObserver(([state])=>entry.classList.toggle('rm26-entry-paused',!state.isIntersecting||document.hidden||reduced.matches));
      observer.observe(entry);entry.rm26Stop=()=>observer.disconnect();
    });
  }
  function motion(){document.querySelectorAll('[data-rm26-entry]').forEach(entry=>{const rect=entry.getBoundingClientRect();entry.classList.toggle('rm26-entry-paused',document.hidden||reduced.matches||rect.bottom<=0||rect.top>=innerHeight);});}
  update();observe();document.addEventListener('visibilitychange',()=>{update();motion();});reduced.addEventListener('change',motion);
  document.addEventListener('shopify:section:load',()=>{update();observe();});
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-rm26-entry]').forEach(entry=>entry.rm26Stop?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rmh-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  function init(root = document) {
    root.querySelectorAll('[data-rmh-story]').forEach(card => {
      if (card.dataset.rmhReady) return;
      card.dataset.rmhReady = 'true';
      let frame = 0;
      const reset = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        card.style.removeProperty('--rmh-glow-x');
        card.style.removeProperty('--rmh-glow-y');
      };
      card.addEventListener('pointermove', event => {
        if (!motion.matches || event.pointerType === 'touch' || frame) return;
        frame = requestAnimationFrame(() => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--rmh-glow-x', `${event.clientX - rect.left}px`);
          card.style.setProperty('--rmh-glow-y', `${event.clientY - rect.top}px`);
          frame = 0;
        });
      }, { passive: true });
      card.addEventListener('pointerleave', reset);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
